import { Backdrop, CircularProgress } from '@mui/material';
import React, { memo } from 'react';

interface Props {
  loading: boolean;
  transparent?: boolean;
}

const Component: React.FC<Props> = ({ loading, transparent = true }) => {
  return (
    <Backdrop
      open={loading}
      sx={{
        color: 'var(--white-color)',
        backgroundColor: transparent ? undefined : 'var(--gray-4-color)',
        zIndex: 20,
      }}
    >
      <CircularProgress />
    </Backdrop>
  );
};

export const FullScreenLoader = memo(Component);
